export default [{
  'n': '中國香港',
  's': [{
    'n': '香港島',
    'c': ['香港島']
  }, {
    'n': '九龍',
    'c': ['九龍']
  }, {
    'n': '新界',
    'c': ['新界']
  }]
}, {
  'n': '中國澳門',
  's': [{
    'n': '澳門半島',
    'c': ['澳門半島']
  }, {
    'n': '氹仔島',
    'c': ['氹仔島']
  }, {
    'n': '路環島',
    'c': ['路環島']
  }, {
    'n': '路氹城',
    'c': ['路氹城']
  }]
}];



// WEBPACK FOOTER //
// ./src/components/DistrictPicker/area/_hk.js